<script setup>
import KnowYourScoreCircle from '@/Pages/DomainScore/Partials/KnowYourScoreCircle.vue';
import Pill from '@/Components/Pill.vue';
</script>

<template>
  <div class="flex flex-col items-center gap-3">
    <div class="pt-6 text-lg font-bold">
      {{ $t('domain_score.partials.overak_risk_card.overall_score') }}
    </div>
    <KnowYourScoreCircle />
    <div class="text-xl">
      {{ $t('domain_score.partials.overak_risk_card.low_risk') }}
    </div>
    <div class="flex gap-1">
      <Pill>A</Pill>
      <Pill>MX</Pill>
      <Pill>NX</Pill>
    </div>
  </div>
</template>
